export default __webpack_public_path__ + "static/media/a011-6.9a83ba4a.svg";